var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "graph-legend", on: { click: _vm.onClick } },
    [
      _vm.isHidden
        ? _c("div", { staticClass: "legend-preview" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isHidden
        ? _c(
            "div",
            [
              _c(
                "transition-group",
                { attrs: { appear: "", name: "fade" } },
                _vm._l(_vm.connectionList, function(connection) {
                  return _c("div", { key: connection.name }, [
                    _c("div", { staticClass: "legend-example" }, [
                      _c("div", { staticClass: "arrow-container" }, [
                        _c("span", {
                          staticClass: "pic arrow",
                          class: connection.name
                        }),
                        _vm._v(" "),
                        _c("hr", { class: connection.name })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "text" }, [
                        _vm._v(_vm._s(connection.text))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("hr", { staticClass: "divider" })
                  ])
                }),
                0
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "arrow-container" }, [
      _c("span", { staticClass: "arrow direct" }),
      _vm._v(" "),
      _c("hr", { staticClass: "direct" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0eeea12d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0eeea12d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/containers/workflow-history/components/workflow-graph/components/graph-legend.vue
// module id = 1659
// module chunks = 0